"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledKeyValueTable = void 0;
var _clsx = _interopRequireDefault(require("clsx"));
var _react = _interopRequireDefault(require("react"));
var _accounting = _interopRequireDefault(require("accounting"));
var _external = require("../external");
var _SectionHeader = require("../SectionHeader/SectionHeader");
var _StyledTable = require("./StyledTable.styles");
var _Status = require("../Status");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var StyledKeyValueTable = function StyledKeyValueTable(props) {
  var title = props.title,
    data = props.data,
    testId = props.testId;
  var classes = (0, _StyledTable.useStyles)();
  return /*#__PURE__*/_react["default"].createElement("div", {
    "data-testid": testId
  }, title && /*#__PURE__*/_react["default"].createElement(_SectionHeader.SectionHeader, {
    text: title,
    className: classes.keyValueSectionHeader
  }), /*#__PURE__*/_react["default"].createElement(_external.Table, {
    className: (0, _clsx["default"])(classes.table, props.className)
  }, /*#__PURE__*/_react["default"].createElement(_external.TableBody, null, data.map(function (record, i) {
    return /*#__PURE__*/_react["default"].createElement(_external.TableRow, {
      key: i,
      className: record.statusValue ? classes.keyValueStatusRow : classes.keyValueRow
    }, /*#__PURE__*/_react["default"].createElement(_external.TableCell, {
      className: record.boldKey ? 'bold' : ''
    }, record.key), /*#__PURE__*/_react["default"].createElement(_external.TableCell, {
      className: record.boldValue ? 'bold' : '',
      "data-dd-privacy": record.datadogMask ? 'mask' : 'allow'
    }, typeof record.value === 'number' ? "".concat(_accounting["default"].format(record.value, 2), " ").concat(record.currency) : record.statusValue ? /*#__PURE__*/_react["default"].createElement(_Status.Status, {
      variant: record.statusVariant
    }, record.value || '-') : record.value));
  }))));
};
exports.StyledKeyValueTable = StyledKeyValueTable;